// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"8984fc83","239":"3cdb2af9","247":"4b6d8064","284":"c287e4d2","627":"248f8fd2","667":"031ce65d","834":"d6865a7d","867":"017954a8","923":"1d3d2684","938":"40b9969c"}[chunkId] + ".chunk.js";
};